import mitt from 'mitt'

import { NotificationType } from './type'

export const NotificationAddEvent = Symbol('NotificationAddEvent')
export const NotificationRemoveEvent = Symbol('NotificationRemoveEvent')

export const emitter = mitt<{
  [NotificationAddEvent]: NotificationType
  [NotificationRemoveEvent]: string
}>()
